import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
  Box,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { CloseOutlined } from '@ant-design/icons';

// project imports
import AuthRegister from 'sections/auth/AuthRegister';

// ==============================|| REGISTER USER MODAL ||============================== //

export default function RegisterModal({ open, onClose, onSuccess }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="xs"
      fullWidth
      scroll="body"
      PaperProps={{
        sx: {
          borderRadius: fullScreen ? 0 : 4,
          backgroundImage: 'none',
          bgcolor: 'background.paper',
          boxShadow: theme.customShadows.z1,
          overflow: 'hidden',
          position: 'relative'
        }
      }}
    >
      {/* Background decoration like Mantis AuthWrapper */}
      <Box
        sx={{
          position: 'absolute',
          top: -50,
          right: -50,
          width: 200,
          height: 200,
          borderRadius: '50%',
          bgcolor: 'primary.lighter',
          opacity: 0.5,
          zIndex: 0
        }}
      />
      
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 2.5, pb: 0, zIndex: 1 }}>
        <Stack>
          <Typography variant="h4" fontWeight={700}>
            Sign Up
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.2 }}>
            Create a new account to get started.
          </Typography>
        </Stack>
        <IconButton onClick={onClose} size="medium" sx={{ color: 'text.secondary' }}>
          <CloseOutlined />
        </IconButton>
      </Stack>

      <DialogContent sx={{ p: 2.5, pt: 1, pb: 4, zIndex: 1 }}>
        <AuthRegister onSuccess={onSuccess} isAdminMode={true} />
      </DialogContent>
    </Dialog>
  );
}

RegisterModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func
};
